import React from 'react';
import config from '../../config';
const App: React.FC = () => {
  return (
    <div className="App">
      <div className="about-page py-5">
        <div className="container">
          <div className="about">
            <div className="row">
              <div className="col-md-10 col-sm-12 mx-auto ">
                <h3 className="text-center fw-bold mb-4">আমাদের সম্পর্কে</h3>
                  <div className="about-content py-3">
                  <article>
                      <div className="h2"><small>ঢাকা, বাংলাদেশের মুসলিম ভাই ও বোনদের জন্য পবিত্র মক্কা ও মদিনায় সুবিধাজনক হজ ও ওমরাহ ভ্রমণের জন্য বাজেট-বান্ধব এবং বিলাসবহুল প্যাকেজ</small></div>
                      <p><strong>হজ</strong>  হল 'ইসলামের পঞ্চম স্তম্ভ' এবং প্রত্যেক মুসলমানের জন্য একটি মৌলিক দায়িত্ব যারা শারীরিকভাবে সুস্থ এবং তার জীবনে অন্তত একবার হজ সফর করার জন্য যথেষ্ট আর্থিক সংস্থান রয়েছে। আক্ষরিক অর্থে, হজ্জের অর্থ হল "একটি স্থানের উদ্দেশ্যে যাত্রা করা।" ইসলামে এর ব্যাপক অর্থ রয়েছে। এটা শুধু একটি জায়গা পরিদর্শন চেয়ে বেশি. এটি একটি আধ্যাত্মিক যাত্রা যা পূর্ববর্তী জীবনের সমস্ত পাপ এবং অতীতে করা সমস্ত পাপের জন্য ক্ষমা প্রার্থনা করার সুযোগ।</p>
                      <p><strong>কাবা</strong> ও <strong>মসজিদে নববীতে </strong>  নামাজ পড়া এবং রাসুলুল্লাহ (সা.) যে রাস্তায় হাঁটাহাঁটি করতেন সেই রাস্তায় হাঁটা প্রত্যেক মুসলমানের সবচেয়ে বড় ইচ্ছা। হজ সফর করা প্রত্যেক মুসলমানের স্বপ্ন কিন্তু খুব কম লোকই তা বাস্তবে রূপান্তর করতে পারে।</p>
                      <h2>সবচেয়ে সাশ্রয়ী মূল্যের অফার ✓ 5 স্টার, ✓ 4 স্টার &amp; ✓ বাংলাদেশ থেকে বিলাসবহুল সুবিধা সহ 3 তারকা হজ প্যাকেজ</h2>
                      <p>আমরা 16 বছরেরও বেশি সময় ধরে হজ এবং ওমরাহ ভ্রমণ শিল্পের মধ্যে কাজ করছি এবং আমরা বলতে যথেষ্ট আত্মবিশ্বাসী যে আমরা আমাদের জিনিসপত্র, সামর্থ্য এবং আতিথেয়তা জানি। আমাদের কয়েক দশকের অভিজ্ঞতা এবং স্বাধীনতা আমাদের বিশেষভাবে নির্বাচিত এয়ার টিকিট, হোটেল পার্টনার বাছাই করার সময় 100% নিরপেক্ষ হতে দেয় এবং এই বিশ্বস্ত সম্পর্কগুলিই পবিত্র ভ্রমণ গন্তব্যগুলির সাথে সর্বোত্তম হজ এবং ওমরাহ প্যাকেজ চুক্তির অগ্রভাগে রাখে। পরিবর্তে, আমাদের গ্রাহকরা সর্বদা এক ধাপ এগিয়ে থাকে, তাদের উপলব্ধ সেরা ওমরাহ চুক্তি সুরক্ষিত করে।</p>
                    </article>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
